import React from 'react';

// NOTE: may want to make this more generic in future, isBoxed as prop etc

const TabBar = ({ children }) => (
  <div className="tabs is-centered">
    <ul>
      { children }
    </ul>
  </div>
)

export default TabBar;


// WEBPACK FOOTER //
// ./src/components/tab-bar/tab-bar.js